import React from 'react';
import OptimizedButton from '../../../../components/agent/UX/OptimizedButton';

const FastTrackInterstitial = ({
  qualityScore,
  onPersonalizeMore,
  onGenerateNow,
  canGenerateNow,
  generateNowReason
}) => {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="w-full max-w-2xl p-8 bg-white rounded-xl shadow-xl">
        <div className="text-center space-y-6">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold text-gray-900">
              🎉 Fast Track Complete!
            </h2>
            <p className="text-lg text-gray-600">
              You've provided everything needed to generate a great itinerary.
            </p>
          </div>

          {qualityScore !== undefined && (
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="text-sm font-medium text-blue-900 mb-1">
                Current Itinerary Quality
              </div>
              <div className="text-3xl font-bold text-blue-600 mb-2">
                {qualityScore}%
              </div>
              <div className="w-full h-2 bg-blue-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-blue-600 rounded-full transition-all duration-300"
                  style={{ width: `${qualityScore}%` }}
                />
              </div>
            </div>
          )}

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-gray-800">
              Want to personalize it even more?
            </h3>
            <p className="text-gray-600">
              Add your ride preferences, show &amp; fireworks picks, dining &amp; restaurant choices,
              character meet &amp; greets, premium experiences, and any celebrations or accessibility
              needs — so your itinerary is tailored just for you.
            </p>

            <div className="flex flex-col gap-3 pt-4 sm:flex-row sm:justify-center">
              <OptimizedButton
                onClick={onPersonalizeMore}
                variant="primary"
                className="w-full sm:w-auto px-8 py-3 text-base font-semibold"
              >
                Personalize More
              </OptimizedButton>
              <OptimizedButton
                onClick={onGenerateNow}
                variant={canGenerateNow ? "primary" : "secondary"}
                disabled={!canGenerateNow}
                className="w-full sm:w-auto px-8 py-3 text-base font-semibold"
              >
                Generate Itinerary Now
              </OptimizedButton>
            </div>

            {!canGenerateNow && generateNowReason && (
              <div className="p-3 mt-2 text-sm text-red-600 bg-red-50 rounded-lg border border-red-200">
                {generateNowReason}
              </div>
            )}
          </div>

          <div className="pt-4 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              <strong>Personalizing more helps us:</strong> Match your favorite rides,
              suggest restaurants you'll love, recommend shows and fireworks viewing spots,
              plan character meet &amp; greets, include premium experiences, and
              accommodate any celebrations or accessibility needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FastTrackInterstitial;
